import { combineReducers } from 'redux';
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _without from 'lodash/without';
import _mapValues from 'lodash/mapValues';
import _union from 'lodash/union';
import _pickBy from 'lodash/pickBy';

import newMemberBody from './modules/create/reducer';
import editMemberBody from './modules/edit/module/reducer';

import {
  REQUEST_MEMBER_BODIES,
  RECEIVE_MEMBER_BODIES,
  RECEIVE_MEMBER_BODIES_ALL,
  REPORT_MEMBER_BODIES_REQUEST_ERROR,
  SELECT_MEMBER_BODY,
  FILTER_MEMBER_BODY_DATA,
  SELECT_ALL_MEMBER_BODIES,
  DESELECT_ALL_MEMBER_BODIES,
  GET_AVAILABLE_STAFF,
} from './actions';

const initialState = {
  pending: false,
  chunks: {},
  selected: [],
  items: [],
  filteredChunks: {},
  filter: '',
  error: null,
  availableStaffMembers: [],
  filteredChunksAll: {},
};

const filterChunks = (chunks, filterHolder = '') => {
  let filteredChunks = chunks;
  const filter = filterHolder.replace(/[^a-zA-Z0-9 ]/g, '');

  if (filter !== '') {
    filteredChunks = _pickBy(chunks, chunk => {
      const rgx = new RegExp(`(${filter})`, 'gi');

      return rgx.test(chunk.name);
    });
  }
  const items = Object.keys(filteredChunks);

  return { filteredChunks, items };
};

const memberBodies = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MEMBER_BODIES:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case GET_AVAILABLE_STAFF:
      return {
        ...state,
        availableStaffMembers: action.value,
      };
    case RECEIVE_MEMBER_BODIES:
      return {
        ...state,
        chunks: action.value,
        selected: [],
        filteredChunks: action.value,
        items: _keys(action.value),
        pending: false,
        error: null,
      };
    case RECEIVE_MEMBER_BODIES_ALL:
      return {
        ...state,
        filteredChunksAll: action.value,
      };
    case FILTER_MEMBER_BODY_DATA:
      return {
        ...state,
        ...filterChunks(state.chunks, action.payload),
        filter: action.payload,
      };

    case REPORT_MEMBER_BODIES_REQUEST_ERROR:
      return {
        pending: false,
        error: action.err,
      };

    case SELECT_MEMBER_BODY: {
      const prevState = state.filteredChunks[action.key].selected;
      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          [action.key]: {
            ...state.filteredChunks[action.key],
            selected: !prevState,
          },
        },
        selected:
          prevState === true
            ? _without(state.selected, action.key)
            : state.selected.concat(action.key),
      };
    }

    case SELECT_ALL_MEMBER_BODIES: {
      const filteredChunks = _pick(state.chunks, state.items);
      const selectedChunks = _mapValues(filteredChunks, chunk => ({
        ...chunk,
        selected: !chunk.default,
      }));
      const selected = _union(
        state.selected,
        Object.keys(filteredChunks).filter(chunk => chunk !== 'default'),
      );

      return {
        ...state,
        filteredChunks: {
          ...state.chunks,
          ...selectedChunks,
        },
        selected,
        selectAll: true,
      };
    }

    case DESELECT_ALL_MEMBER_BODIES:
      return {
        ...state,
        filteredChunks: _mapValues(state.chunks, chunk => ({
          ...chunk,
          selected: false,
        })),
        selected: [],
        selectAll: false,
      };

    default:
      return state;
  }
};

export default combineReducers({
  data: memberBodies,
  newMemberBody,
  editMemberBody,
});
